<app-title-bar
  title="Service Status"
  description="Internal liveness of gateway upstreams. Green means the process responded to /health — not full dependency health."
  [showButton]="false"
>
  <ng-template #buttonContent>
    <button
      type="button"
      class="btn btn-secondary btn-medium"
      [disabled]="refreshing || loading"
      (click)="refresh()"
    >
      {{ refreshing || loading ? 'Refreshing…' : 'Refresh' }}
    </button>
  </ng-template>
</app-title-bar>

@if (loading) {
  <app-loading-table-shimmer [columns]="shimmerColumns" [rows]="8"></app-loading-table-shimmer>
} @else {
  @if (errorMessage) {
    <div class="status-refresh-error" role="alert">{{ errorMessage }}</div>
  }

  @if (services.length === 0) {
    <app-empty-result
      [title]="'Unable to load status'"
      [description]="errorMessage || 'No service status returned'"
    >
    </app-empty-result>
  } @else {
    <div class="status-summary" [attr.data-overall]="overall">
      <div class="status-summary-main">
        <mat-chip [ngClass]="'chip-' + overallSeverity(overall)" disableRipple>
          {{ overall ? overall.toUpperCase() : 'UNKNOWN' }}
        </mat-chip>
        <span class="status-summary-label">{{ overallLabel(overall) }}</span>
      </div>
      <div class="status-summary-meta" *ngIf="checkedAt">
        <span>Checked {{ checkedAt | date: 'medium' }}</span>
        <span *ngIf="cached" class="cached-badge">cached</span>
      </div>
    </div>

    <div class="status-table-wrap">
      <table class="status-table">
        <thead>
          <tr>
            <th>Service</th>
            <th>Status</th>
            <th>Latency</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          @for (row of services; track row.name) {
            <tr>
              <td>
                <div class="service-name">{{ row.label }}</div>
                <div class="service-key">{{ row.name }}</div>
              </td>
              <td>
                <mat-chip [ngClass]="'chip-' + serviceSeverity(row.status)" disableRipple>
                  {{ serviceLabel(row.status) }}
                </mat-chip>
              </td>
              <td>{{ row.latencyMs }} ms</td>
              <td class="detail-cell">{{ row.error || '—' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
}
